import { render, staticRenderFns } from "./FormResidentialSeo.vue?vue&type=template&id=424f0c8e&scoped=true&lang=pug&"
import script from "./FormResidentialSeo.vue?vue&type=script&lang=js&"
export * from "./FormResidentialSeo.vue?vue&type=script&lang=js&"
import style0 from "./FormResidentialSeo.vue?vue&type=style&index=0&id=424f0c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f0c8e",
  null
  
)

export default component.exports